<footer class="footer">
  <span><!--<a href="https://viotalworks.com" target="_blank">ServicePlus</a>--> &copy; 2024.</span>
  <span class="ml-auto">Powered by 
    <!--Mahindra CIE India.-->
    <img class="brand-image" src="/assets/img/brand/logo-high-original.png" style="width:70px;"/>
  
  </span>
</footer>
